<template>
  <header class="zui-header">
    <el-row :gutter="20">
        <el-col :span="4"><logo :type="logoType" href="/"></logo></el-col>
        <el-col :span="16">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#fff"
            text-color="#000"
            active-text-color="#07c160"
          >
            <el-menu-item index="1">首页</el-menu-item>
            <el-menu-item index="2">数字化转型</el-menu-item>
            <el-menu-item index="3">关于我们</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="4">
          <el-select v-model="lan_value" placeholder="请选择" class="lan-select" :popper-append-to-body="false" @change="lanChange(lan_value)">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
  </header>
</template>
<script>
  import './less/header.less'
  import Logo from './Logo'
  export default {
    props: {
      logoType: {
        default: 'yuexinyun'
      },
      activeIndex: {
        default: '1'
      }
    },
    components: {Logo},
    data() {
        return {
          lan_value: 1,
          options: [
            { value: 1 , label: '中文' },
            { value: 2 , label: 'English' }
          ]
      }
    },
    methods: {
    handleSelect(key) {
      switch (key) {
        case "1":
          this.$router.push({ path: "/" });
          break;
        case "2":
          this.$router.push({ path: "/transformation" });
          break;
        case "3":
          this.$router.push({ path: "/about" });
          break;
      }
    },
    lanChange(val) {
      if(val == 1) {
        window.location.href = "https://yuexin.cn/";
      } else {
        window.location.href = "https://yuexin.cn/en/";
      }
    }
  }
  }
</script>
<style scoped>
.lan-select {
  margin-top: 13px;
}
.zui-header /deep/ .lan-select .el-input__inner{
  border:none;
}
.zui-header /deep/ .lan-select .el-input__suffix {
  right: 100px !important;
}
.zui-header /deep/ .lan-select .el-select-dropdown__item.selected{
    color: #00AA50;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue